export default __webpack_public_path__ + "static/media/clock_active.3dd066b0.png";